import React, { useEffect } from 'react';
import { RadioGroup, Select } from 'components';
import {  updateFormField } from 'store/forms/actions';
import {Form} from 'antd';
import {FormField} from 'components';
import { Row, Col } from 'antd';
import { jvBanks } from './jvBanks';
import { useSelector, useDispatch } from 'react-redux';
import { formFieldsBank } from './formField';
import { omit, get, moment } from 'lodash';
import { useForm } from 'antd/lib/form/Form';
import { useLocation } from 'react-router-dom';
import { types } from 'store/forms/types';

const BankData = ({ disabled, extended }) => {
  const dispatch = useDispatch();
  const bnkBank = useSelector(state => state.forms?.carrier?.bnkBank); 
  // const jvBanks = useSelector(state => state.forms.items?.jvBanks);
  const viewMode = useSelector(state => state.forms.carrier?.viewMode);
  const location = useLocation();
  const activeTaskName = useSelector(state =>
    location.pathname.includes("apptrack")
      ? state.appTrack?.apptrackDetails?.activeTaskName
      : state.forms?.task?.taskName
  );
  const disableBankField =
    viewMode && activeTaskName === 'task.name.complete';

   const [form] = useForm();
    const carrier = useSelector(state => state.forms.carrier);

  const handleChange = ({ key, type, event }) => {
      console.log("value:", key, type, event);
      let newValue;
    
      if (type === 'text' || type === 'textarea' || type === 'radio') {
        newValue = event.target.value;
      } else if (type === 'date') {
        newValue = new Date(event).toLocaleDateString("en-US");
      } else if (type === 'checkbox') {
        newValue = event.target.checked;
      } else if (type === 'businessSize') {
        newValue = typeof event === 'string' ? event : event.event || event;
      } else if (type === 'select' || type === 'number' || type === 'numberWithDecimals') {
        newValue = event;
      }
    
      dispatch(
        updateFormField({
          group: 'carrier',
          key,
          value: newValue,
        })
      );

      if (key === 'bnkBank') {
      dispatch({
        type: types.SET_BANK_CHANGED,
        payload: true
      });
    }
  };

  useEffect(() => {
      form.setFieldsValue({
        bnkBank: carrier?.bnkBank,  
      });
    }, [form, carrier.bnkBank]);

  const renderFieldValue = field => {
    const value = get(carrier, field.name, '');
    return field.type === 'date' ? (value ? moment(value) : '') : value;
  };

  return (
    <div className="bank-form-container">
      <Form
              form={form}
              initialValues={{
                ...carrier,
              }}
              trigger="onChange"
              className='basicInfoForm'
            >
      <p className="mt-6 mr-0 color-blue-3 text-bold font-size-24">
          Πιστωτικό Ίδρυμα
        </p>
      <Row gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}>
      {formFieldsBank.map((field, index) => {
        return (
        <Col span={8} className="pt-1 pb-1">
          <Form.Item
            name={[field.name]}
            rules={field.rules}
            value={renderFieldValue(field)}
            validateFirst
          >
            <FormField
              key={index}
              disabled={disableBankField}
              style={
                 disableBankField
                  ? { pointerEvents: 'none', cursor: 'not-allowed' }
                  : {}
              }
              className={viewMode ? 'custom-checkbox-disabled' : ''}
              {...omit(field, ['span', 'rules'])}
              onChange={value =>
                handleChange({
                  key: field.name,
                  type: field.type,
                  event: value,
                })
              }
            />
          </Form.Item>
          
        </Col> )
        })
      }
      
      </Row>
      <RadioGroup
        label={<div>Πρόκειται για Έκδοση Κοινοπρακτικού Δανείου;<span className="color-red"> *</span></div>}
        defaultValue={'Όχι'}
        disabled={viewMode}
        options={[
          { label: 'Ναι', value: 'Ναι', id:'yes' },
          { label: 'Όχι', value: 'Όχι', id:'no' },
        ]}
        name={'bnkSyndLoan'}
        id={'bnkSyndLoan'}
        checked={carrier.bnkSyndLoan}
        value={carrier.bnkSyndLoan}
        onChange={event =>
          handleChange({ key:'bnkSyndLoan', type: "radio", event: event })
        }
      />
      {/* {!bnkBank && ( 
        <div className='color-red'>Το πεδίο είναι υποχρεωτικό</div>        
      )
      } */}
      </Form>
    </div>
  );
};

export default BankData;
